export default __webpack_public_path__ + "6b201a2535831b37aa90f96039609d40.png";